import { render, staticRenderFns } from "./CallParticipantTeaser.vue?vue&type=template&id=0f2f9159&scoped=true&"
import script from "./CallParticipantTeaser.vue?vue&type=script&lang=js&"
export * from "./CallParticipantTeaser.vue?vue&type=script&lang=js&"
import style0 from "./CallParticipantTeaser.vue?vue&type=style&index=0&id=0f2f9159&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2f9159",
  null
  
)

export default component.exports